module.exports = __webpack_public_path__ + "d98f7e335e2e42e752c1ed9448f180b6.png";